import { Accordion, ContentType } from '../../../common/components/Accordion/Accordion';
import { ShowingIndexProvider } from '../../../common/components/Accordion/useShowingIndex';
import { ContentWrapper, Title } from './FAQ.styles';

interface Props {
  questions: ContentType[];
}

export const FAQ = ({ questions }: Props) => (
  <ContentWrapper>
    <Title>The things you need to know about the flu vaccine in Australia</Title>
    <ShowingIndexProvider>
      <Accordion questions={questions} />
    </ShowingIndexProvider>
  </ContentWrapper>
);
